import React from 'react';

function ServicesPage() {
    return <div>Services Page</div>;
}

export default ServicesPage;
